<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: { type: String, default: '' },
  sampleVariables: { type: Object, default: () => ({}) },
  fieldErrors: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['update:modelValue', 'insert-variable']);

const { t } = useI18n();
const bodyTextarea = ref(null);

const onInput = e => emit('update:modelValue', e.target.value);

const onInsertVariable = () => emit('insert-variable', bodyTextarea.value);
</script>

<template>
  <div class="space-y-2">
    <div class="flex items-center justify-between">
      <label class="text-xs font-medium text-n-slate-11">
        {{ t('INBOX_MGMT.TEMPLATES.CREATE.BODY') }}
        <span class="text-n-ruby-9">*</span>
      </label>
      <span
        class="text-[11px]"
        :class="modelValue.length > 950 ? 'text-n-ruby-9' : 'text-n-slate-10'"
      >
        {{ modelValue.length }}/1024
      </span>
    </div>
    <textarea
      ref="bodyTextarea"
      :value="modelValue"
      rows="6"
      maxlength="1024"
      class="w-full px-3 py-2 rounded-lg outline outline-1 outline-n-weak bg-transparent text-sm text-n-slate-12 focus:outline-n-brand resize-none"
      :placeholder="t('INBOX_MGMT.TEMPLATES.CREATE.BODY_PH')"
      @input="onInput"
    />
    <div class="flex items-center justify-between">
      <p v-if="fieldErrors.body" class="text-[11px] text-n-ruby-9">
        {{ fieldErrors.body }}
      </p>
      <div class="ml-auto">
        <button
          type="button"
          class="h-8 px-3 rounded-lg text-xs bg-n-slate-3 text-n-slate-12 hover:bg-n-slate-4"
          @click="onInsertVariable"
        >
          {{ t('INBOX_MGMT.TEMPLATES.CREATE.INSERT_VARIABLE') }}
        </button>
      </div>
    </div>
  </div>
</template>
